import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';
import { v4 as uuidv4 } from 'uuid';

import { setHTMLProperties } from './remark-helpers';

export const remarkNodeId: Plugin = () => {
  return tree => {
    /**
     * Assigns a unique ID to all nodes so we can restore hProperties during the
     * rehype pass in `rehype-preserve-properties`.
     */
    visit(tree, node => {
      setHTMLProperties(node, { id: uuidv4() });
    });
  };
};
